module.exports = __webpack_public_path__ + "static/avatar-397d85fb26a705f4bc11f0ec8d16c268.png";